<template>
  <div class="similar-jobs-search-bar d-flex flex-column ga-2">
    <!-- Toggle Groups -->
    <div class="d-flex w-100">
      <div class="d-flex w-100 ga-2 flex-wrap">
        <!-- Local vs Global Toggle -->
        <DpplToggleTabs
          class="flex-grow-1"
          v-model="locality"
          :tabs="['Local', 'Global']"
        />

        <!-- My Org vs Market Toggle -->
        <DpplToggleTabs
          class="flex-grow-1"
          v-model="scope"
          :tabs="['My Org', 'Market']"
        />
      </div>
    </div>

    <!-- Search Input -->
    <v-text-field
      v-model="searchQuery"
      base-color="textLight"
      color="textLight"
      placeholder="Search for a job/title"
      variant="outlined"
      density="compact"
      hide-details
      rounded="lg"
      @update:model-value="handleSearchChange"
    >
      <template #prepend-inner>
        <v-icon
          icon="material-symbols:search"
          size="20"
          color="iconDefault"
        />
      </template>
    </v-text-field>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import DpplToggleTabs from '@ui/components/general/DpplToggleTabs/DpplToggleTabs.vue';

const props = defineProps({
  jobs: {
    type: Array,
    required: true,
    default: () => [],
  },
  isLoading: {
    type: Boolean,
    required: true,
    default: false,
  },
});

const emit = defineEmits(['search', 'locality-change', 'scope-change', 'search-upgrade']);

const locality = ref('Local');
const scope = ref('My Org');
const searchQuery = ref('');

const handleSearchChange = (value) => {
  emit('search', value);
};

watch(locality, (newValue) => {
  emit('locality-change', newValue === 'Local' ? 'local' : 'global');
});

watch(scope, (newValue) => {
  emit('scope-change', newValue === 'My Org' ? 'organization' : 'market');
});

watch(() => props.isLoading, (newValue, oldValue) => {
  let text = '';

  if (oldValue && !newValue && props.jobs.length === 0) {
    // Similar jobs were loading, then finished loading, but no jobs were found
    if (scope.value === 'My Org') {
      if (locality.value === 'Local') {
        // My Org Local -> My Org Global
        locality.value = 'Global';
        text = 'No similar local jobs found in your organization. Showing global results instead.';
      } else {
        // My Org Global -> Market Local
        scope.value = 'Market';
        locality.value = 'Local';
        text = 'No similar jobs found in your organization. Showing market results instead.';
      }
    } else {
      if (locality.value === 'Local') {
        // Market Local -> Market Global
        locality.value = 'Global';
        text = 'No similar local jobs found in the market. Showing global results instead.';
      } else {
        text = 'No similar jobs found globally.';
      }
    }

    emit('search-upgrade', text);
  }
});
</script>
